import React, { useEffect, useState } from "react";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import Footer from "./Footer";
import { FcGoogle } from "react-icons/fc";
import "../../index.css";
import {
  getclusterbyDomain,
  getDomainForWhiteLabeling,
  name,
} from "../../services/white_label";
import "../dashboard/dashboard.css";
import Register from "../dashboard/register";
import {
  getDataFromLocalStorage,
  removeDataFromLocalStorage,
} from "../../services/localStorage";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useStores } from "../../store";
import LoginButton from "../reusble_components/login/loginbutton";
import Mail from "../reusble_components/login/mail";
import { MdArrowBackIosNew } from "react-icons/md";
import { GoLock } from "react-icons/go";
import { VscMail } from "react-icons/vsc";
import "./signupPage.css";
import NewPlatformPopup from "../reusble_components/popup/NewPlatformPopup";
import {
  getCurrentUser,
  loginRecruiterWithEmail,
  loginRecruiterWithGoogle,
} from "../../api/authApi";
// import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
export default function SignupWithGoogle() {
  const navigate = useNavigate();
  const { PopupStore, UserStore } = useStores();

  const [loading, setloading] = useState(false);
  const [showTermAndConditions, setshowTermAndConditions] = useState(false);
  const [register, setRegister] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [showPassword, setshowPassword] = useState(false);

  const [newUserDetails, setnewUserDetails] = useState({});
  const [rcode, setRcode] = useState("");
  const [showNewPlatformPopup, setShowNewPlatformPopup] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [pendingUserData, setPendingUserData] = useState(null);

  const checkForTheUserCredentials = async () => {
    setloading(true);
    try {
      const meRes = await getCurrentUser();

      if (meRes?.success && meRes?.data) {
        const user = meRes.data;

        if (
          user?.role?.role === "student" &&
          getDomainForWhiteLabeling() === "app.reaidy.io"
        ) {
          setPendingNavigation(user?.role?.role);
          setPendingUserData(user);
          setShowNewPlatformPopup(true);
          return;
        }

        if (!user?.isAccountVerified) {
          navigate("/AccountVerification");
          return;
        }

        return navigateUsingRole(user?.role?.role, user);
      }
    } catch (e) {
      // ignore - user is not logged in
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    checkForTheUserCredentials();
    gettingParmsFromUrl();
  }, []);
  var referal = false;
  const gettingParmsFromUrl = () => {
    const url = window.location.href;
    const urlParams = new URL(url);
    const referalCode = urlParams.searchParams.get("refer");
    console.log(referalCode);
    setRcode(referalCode);
    if (referalCode) {
      setHasReferralCode(true);
    }
  };

  const [hasReferralCode, setHasReferralCode] = useState(referal);
  const group = new URLSearchParams(window.location.search).get("group");
  console.log("hello", group);
  const registerUser = async (name, mail, gId, pic) => {
    const body = {
      name: name,
      mail: mail,
      gId: gId,
      role: "647ce2e8c41bee677ea39fc4",
      pic: pic,
      rCode: rcode,
    };

    if (!localStorage.getItem("register")) {
      try {
        setloading(true);
        let newBody = body;
        newBody = {
          ...newBody,
          cluster: getclusterbyDomain(),
        };
        axios
          .post(`/user/register?groupId=${group}`, newBody)
          .then((res) => {
            setloading(false);
            console.log(res);
            if (res.status === 200) {
              return;
            }
            alert("Something went wrong. Please try again later. error: 25");
          })
          .catch((err) => {
            setloading(false);
            console.log(err);
            alert("Something went wrong. Please try again later. error: 29");
          });
      } catch (error) {
        console.error(error);
        alert("Something went wrong. Please try again later. error: 33");
      }
    }
  };

  const navigateUsingRole = async (role, userData = null) => {
    // Mark the session as authenticated so AutoLogin's pre-paint guard allows
    // protected routes to render without flashing back to login.
    sessionStorage.setItem("auth", "1");

    // Save user data to store if provided
    if (userData) {
      UserStore.setUserDetails(userData);
    }

    // Block unverified recruiter accounts before any navigation
    if (userData && !userData.isAccountVerified) {
      navigate("/AccountVerification");
      return;
    }

    // get the redirect url from local storage

    /* ------------------- REDIRECT TO THE URL IF IT IS THERE ------------------- */
    const redirectUrl = await getDataFromLocalStorage("redirectUrl");
    console.log(redirectUrl);
    if (redirectUrl) {
      removeDataFromLocalStorage("redirectUrl");
      window.location.href = redirectUrl;
      return;
    }

    /* ----------------------------------- XXX ---------------------------------- */
    const whiteLabelDomain = getDomainForWhiteLabeling();
    if (whiteLabelDomain === "app.naukritube.in" && role === "student") {
      return navigate("/dashboard/jobinternship");
    }

    switch (role) {
      case "student":
        return navigate("/dashboard/dashboard");
      case "company":
        return navigate("/company/dashboard");
      case "consultancy":
        return navigate("/company/dashboard");

      default:
        return navigate("/company/dashboard");
        break;
    }
  };

  const loginUser = async (mail, gId, name, pic) => {
    try {
      setloading(true);

      const loginRes = await loginRecruiterWithGoogle({
        mail,
        gId,
      });

      if (!loginRes?.success) {
        setloading(false);
        if (loginRes.status === 404) {
          setnewUserDetails({
            name: name,
            mail: mail,
            gId: gId,
            role: "647ce2e8c41bee677ea39fc4",
            pic: pic,
          });
          setshowTermAndConditions(true);
          return;
        }

        PopupStore.setTitle(loginRes.title || "Login Failed");
        PopupStore.setMessage(
          loginRes.message || "Something went wrong. Please try again later.",
        );
        PopupStore.setAlert(true);
        return;
      }

      const meRes = await getCurrentUser();
      setloading(false);

      if (!meRes?.success || !meRes?.data) {
        PopupStore.setTitle(meRes?.title || "Login Failed");
        PopupStore.setMessage(
          meRes?.message || "Something went wrong. Please try again later.",
        );
        PopupStore.setAlert(true);
        return;
      }

      const user = meRes.data;

      if (group && user?._id) {
        try {
          await axios.post(
            `/user/add-user-to-group?userId=${user._id}&groupId=${group}`,
            {},
            { withCredentials: true },
          );
          alert("sucessfully added into the group");
        } catch {
          // ignore group add failure for now
        }
      }

      if (
        user?.role?.role === "student" &&
        getDomainForWhiteLabeling() === "app.reaidy.io"
      ) {
        setPendingNavigation(user?.role?.role);
        setPendingUserData(user);
        setShowNewPlatformPopup(true);
        return;
      }

      if (!user?.isAccountVerified) {
        navigate("/AccountVerification");
        return;
      }

      return navigateUsingRole(user?.role?.role, user);
    } catch (error) {
      setloading(false);
      console.error(error);
      PopupStore.setTitle("Login Failed");
      PopupStore.setMessage("Something went wrong. Please try again later.");
      PopupStore.setAlert(true);
    }
  };

  const onSuccessLogin = (response) => {
    const userObject = jwt_decode(response.credential);

    console.log("userObject", userObject);
    loginUser(
      userObject?.email,
      userObject?.sub,
      userObject?.name,
      userObject?.picture,
    );
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log("tokenResponse", tokenResponse);
      onSuccessLogin(tokenResponse);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function submitButton() {
    return (
      <button
        disabled={!enableSubmit}
        className={`gil-reg text-lg ${
          enableSubmit ? "bg-primary" : " bg-slate-300"
        } text-white px-4 py-2 rounded-md shadow-md hover:shadow-lg focus:outline-none w-full`}
        onClick={() => {
          if (hasReferralCode && rcode === "") {
            alert("Please enter a referral code");
            return;
          }
          setshowTermAndConditions(false);
          setRegister(true);
          registerUser(
            newUserDetails.name,
            newUserDetails.mail,
            newUserDetails.gId,
            newUserDetails.pic,
          );
        }}
      >
        Continue
      </button>
    );
  }

  const termsAndConditionsWithSubmitButton = () => {
    return (
      <div className="flex flex-col items-center justify-center md:justify-start w-[90%] lg:w-[50%] md:w-[50%] md:h-[20vh] md:space-y-3">
        <div className="flex flex-col md:justify-between h-60 w-full">
          <div className="flex items-center justify-start mb-[25%] md:mb-[40%] -mt-[10%] w-full cursor-pointer">
            <MdArrowBackIosNew className="text-black text-sm mr-1" />
            <span className="text-xs text-black font-bold">Back</span>
          </div>
          <div className="flex items-center space-x-2 text-xl pb-0 md:pb-2 lg:pb-2">
            <input
              type="checkbox"
              id="acceptTerms"
              className="text-primary h-5 w-5"
              onChange={(e) => {
                setEnableSubmit(e.target.checked);
              }}
            />
            <label htmlFor="acceptTerms" className="flex gap-2 items-center">
              <p className="whitespace-nowrap">I accept the </p>
              <a
                href="https://www.reaidy.in/page-terms.html"
                target="_blank"
                className="text-primary hover:underline whitespace-nowrap"
              >
                Terms and Conditions
              </a>
            </label>
          </div>
          <div className="h-24 py-3 w-full">
            <div className="flex space-x-4 items-center">
              <p>Do you Have a Referal Code</p>
              <label className="flex items-center space-x-1">
                <input
                  type="radio"
                  value="yes"
                  checked={hasReferralCode}
                  onChange={() => setHasReferralCode(true)}
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  type="radio"
                  value="no"
                  checked={!hasReferralCode}
                  onChange={() => setHasReferralCode(false)}
                />
                <span>No</span>
              </label>
            </div>
            {hasReferralCode && (
              <div className="mt-2">
                <input
                  required
                  disabled={!enableSubmit}
                  type="text"
                  className="border-2 px-2 py-2 border-gray-800 rounded-lg opacity-75 tracking-[3px] border-opacity-50 w-full"
                  placeholder="Referal code"
                  value={rcode}
                  onChange={(e) => {
                    setRcode(e.target.value);
                    console.log(rcode);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="w-full">{submitButton()}</div>
      </div>
    );
  };

  const handleNewPlatformConfirm = async () => {
    const meRes = await getCurrentUser();

    if (meRes?.success && meRes?.data?._id) {
      const userId = meRes.data._id;
      localStorage.clear();
      setShowNewPlatformPopup(false);
      window.location.href = `https://user.reaidy.io/${userId}`;
      return;
    }

    localStorage.clear();
    setShowNewPlatformPopup(false);
  };

  const handleNewPlatformCancel = () => {
    setShowNewPlatformPopup(false);
    if (pendingNavigation && pendingUserData) {
      navigateUsingRole(pendingNavigation, pendingUserData);
    }
  };

  return (
    <>
      {register ? (
        <>
          <Register
            onBack1={() => {
              setRegister(false);
              setshowTermAndConditions(true);
            }}
          />
          {/* <HelpCenter position="/" /> */}
        </>
      ) : (
        <div className="flex flex-col items-center justify-between mx-auto md:w-full lg:w-full w-[100%] min-h-screen gil-reg bg-[#F8F2E9]">
          <Loader loader={loading} />
          <NewPlatformPopup
            isOpen={showNewPlatformPopup}
            onClose={handleNewPlatformCancel}
            onConfirm={handleNewPlatformConfirm}
            onCancel={handleNewPlatformCancel}
          />

          {showTermAndConditions ? (
            termsAndConditionsWithSubmitButton()
          ) : (
            <div className="flex flex-col items-center gap-6 tc1:mt-14 tc3:mt-0 md:mt-14">
              <form
                className="flex flex-col gap-6 tc1:w-80 md:w-96"
                onSubmit={async (e) => {
                  setloading(true);
                  e.preventDefault();

                  // Import FingerprintJS dynamically to ensure it's loaded before use
                  const FingerprintJS =
                    await import("@fingerprintjs/fingerprintjs");

                  // Initialize the FingerprintJS library
                  const fp = await FingerprintJS.load();

                  // Get the visitor identifier (fingerprint)
                  const fingerprint = await fp.get();

                  const payload = {
                    userId: e.target.userId?.value?.trim(),
                    email: e.target.email?.value?.trim(),
                    password: e.target.password?.value?.trim(),
                    loginTime: new Date().getTime(),
                    macAddress: "-",
                    fingerPrint: fingerprint.visitorId,
                    browserName: navigator.userAgent,
                    systemSize: {
                      width: window.innerWidth,
                      height: window.innerHeight,
                    },
                    referralSource: document.referrer,
                    operatingSystem: navigator.platform,
                    platform: navigator.userAgent,
                    geolocation: await new Promise((resolve) => {
                      navigator.geolocation.getCurrentPosition(
                        (pos) =>
                          resolve({
                            latitude: pos.coords.latitude,
                            longitude: pos.coords.longitude,
                          }),
                        () => resolve(null),
                      );
                    }),
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    connectionType: navigator.connection
                      ? navigator.connection.effectiveType
                      : "unknown",
                  };

                  console.log(payload);

                  const loginRes = await loginRecruiterWithEmail(payload);

                  if (!loginRes?.success) {
                    setloading(false);
                    PopupStore.setTitle(loginRes.title || "Login Failed");
                    PopupStore.setMessage(
                      loginRes.message ||
                        "Something went wrong. Please try again later.",
                    );
                    PopupStore.setAlert(true);
                    return;
                  }

                  const meRes = await getCurrentUser();
                  setloading(false);

                  if (!meRes?.success || !meRes?.data) {
                    PopupStore.setTitle(meRes?.title || "Login Failed");
                    PopupStore.setMessage(
                      meRes?.message ||
                        "Something went wrong. Please try again later.",
                    );
                    PopupStore.setAlert(true);
                    return;
                  }

                  const user = meRes.data;

                  if (
                    user?.role?.role === "student" &&
                    getDomainForWhiteLabeling() === "app.reaidy.io"
                  ) {
                    setPendingNavigation(user?.role?.role);
                    setPendingUserData(user);
                    setShowNewPlatformPopup(true);
                    return;
                  }

                  if (!user?.isAccountVerified) {
                    navigate("/AccountVerification");
                    return;
                  }

                  return navigateUsingRole(user?.role?.role, user);
                }}
              >
                <div className="flex justify-between w-full">
                  {/* <h1
                    onClick={() =>
                      navigate("/register?employer=6551bda478cf4fd1e4316dc9")
                    }
                    className="text-lg cursor-pointer text-primary underline ml-16"
                  >
                    Register as an Employer
                  </h1> */}
                </div>

                <div className="w-full text-left">
                  <h1 className="font-bold text-black text-2xl">
                    Login to your account
                  </h1>
                  <p className="text-xs text-gray-500 mt-2">
                    Welcome! Choose your login method
                  </p>
                </div>

                <Mail
                  placeholder="Enter mail ID"
                  id="email"
                  name="email"
                  icon={
                    <VscMail className="text-[#000000] text-lg mr-4 ml-3" />
                  }
                  required={true}
                />

                <div className="flex items-center bg-[#FFFFFF] rounded-lg p-2 h-12 w-full">
                  <GoLock className="text-lg text-[#000000] mr-4 ml-3" />
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    className="flex-1 outline-none bg-[#FFFFFF]"
                    placeholder="Password"
                    required
                  />
                  {showPassword ? (
                    <AiOutlineEye
                      onClick={() => setshowPassword(false)}
                      className="text-xl opacity-50 cursor-pointer"
                    />
                  ) : (
                    <AiOutlineEyeInvisible
                      onClick={() => setshowPassword(true)}
                      className="text-xl opacity-50 cursor-pointer"
                    />
                  )}
                </div>

                <span
                  className="text-xs ml-auto -mt-3 text-primary cursor-pointer"
                  onClick={() => navigate("/reset-password")}
                >
                  Forgot Password?
                </span>

                <LoginButton
                  type="submit"
                  buttonName="Login Now"
                  color="#FF6B00"
                  padding="24"
                  rounded="lg"
                />
              </form>

              <span className="text-center text-lg -mt-5">
                Don't have an account?{" "}
                <a
                  onClick={() => {
                    if (name() === "Naukritube") {
                      navigate("/register");
                    } else {
                      window.location.href = "https://www.reaidy.io/signup";
                    }
                  }}
                  className="text-primary cursor-pointer text-lg"
                >
                  Sign up Now
                </a>
              </span>

              <div className="w-full text-center mt-2 mb-5">
                <p className="text-[#FF6B00] text-lg">OR</p>
              </div>
              <div className="w-full max-w-[385px] relative">
                <div className="relative z-0">
                  <div className="bg-[#ffffff] w-full h-12 rounded-md absolute pointer-events-none top-0 z-50 flex gap-3 items-center justify-center">
                    <FcGoogle className="text-xl" />
                    <span className="text-lg text-[#000000]">
                      Continue with Google
                    </span>
                  </div>
                  <GoogleLogin
                    id="google-login"
                    theme="outline"
                    text="continue_with"
                    size="large"
                    shape="rectangular"
                    width="100%"
                    logo_alignment="center"
                    onSuccess={(credentialResponse) => {
                      onSuccessLogin(credentialResponse);
                      console.log(credentialResponse);
                    }}
                    onError={() => alert("Login Failed")}
                  />
                </div>
              </div>

              <div className="md:block md:mt-auto flex items-center justify-center md:items-end">
                <Footer className="bg-blue-500 text-white p-6 w-full" />
              </div>

              {/* <div className="w-full flex items-center justify-center rounded-md h-12">
                <div className="bg-[#FF6B00] text-2xl  rounded-l-md text-white w-[20%] flex items-center justify-center h-12">
                  <FaGoogle />
                </div>
                <button
                  className="bg-[#FFFFFF] text-lg text-[#000000] px-4 h-12 rounded-r-md focus:outline-none w-[80%] "
                  // onClick={() => googleLoginRef.current?.click()} // Click hidden GoogleLogin button
                  onClick={() => login()}
                >
                  Continue with Google
                </button>

                <div className=" hidden mb-1 tc1:pl-10 md:pl-0 ">
                  <GoogleLogin
                    id="google-login"
                    theme="outline"
                    text="continue_with"
                    size="large"
                    shape="rectangular"
                    width={window.innerWidth > 999 ? "385px" : "360px"}
                    logo_alignment="center"
                    onSuccess={(credentialResponse) => {
                      onSuccessLogin(credentialResponse);
                    }}
                    onError={() => alert("Login Failed")}
                  />
                </div>
              </div> */}
            </div>
          )}

          {/* <Footer className="bg-blue-500 text-white p-6 w-full mt-4" /> */}
        </div>
      )}
    </>
    // <div className="w-[95vw] h-[100vh] gil-reg">
    //   <div className="flex flex-row justify-center items-center h-full w-full ">
    //     <GoogleLogin
    //       onSuccess={(credentialResponse) => {
    //         console.log(credentialResponse);
    //         onSuccessLogin(credentialResponse);
    //       }}
    //       onError={() => {
    //         console.log("Login Failed");
    //         alert("Login Failed");
    //       }}
    //     />
    //   </div>
    // </div>
  );
}
